import type { IconName } from "@agent/uiSchema";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBell,
  faCalendar,
  faCalendarCheck,
  faChartLine,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faClipboard,
  faClipboardList,
  faClock,
  faComment,
  faDroplet,
  faEnvelope,
  faFileLines,
  faHeartPulse,
  faListCheck,
  faMicroscope,
  faNotesMedical,
  faPaw,
  faPhone,
  faPills,
  faStethoscope,
  faSyringe,
  faTemperatureHalf,
  faTriangleExclamation,
  faUser,
  faUserDoctor,
  faVial,
  faWeightScale,
} from "@fortawesome/pro-solid-svg-icons";

/** One icon per `IconName` (mirrors brian's `modules/task/ui_schema.py`). */
export const UI_ICONS: Record<IconName, IconDefinition> = {
  "triangle-exclamation": faTriangleExclamation,
  "circle-exclamation": faCircleExclamation,
  "circle-info": faCircleInfo,
  "circle-check": faCircleCheck,
  "circle-xmark": faCircleXmark,
  clipboard: faClipboard,
  "clipboard-list": faClipboardList,
  "notes-medical": faNotesMedical,
  "file-lines": faFileLines,
  stethoscope: faStethoscope,
  "heart-pulse": faHeartPulse,
  syringe: faSyringe,
  pills: faPills,
  vial: faVial,
  microscope: faMicroscope,
  "weight-scale": faWeightScale,
  "temperature-half": faTemperatureHalf,
  droplet: faDroplet,
  paw: faPaw,
  calendar: faCalendar,
  "calendar-check": faCalendarCheck,
  clock: faClock,
  user: faUser,
  "user-doctor": faUserDoctor,
  phone: faPhone,
  envelope: faEnvelope,
  bell: faBell,
  "chart-line": faChartLine,
  "list-check": faListCheck,
  comment: faComment,
};

/** Own-property check so an inherited key like "toString" isn't an icon; `Object.hasOwn` needs es2022. */
export const uiIcon = (
  name: IconName | undefined,
): IconDefinition | undefined =>
  name && Object.prototype.hasOwnProperty.call(UI_ICONS, name)
    ? UI_ICONS[name]
    : undefined;
